import './Skeleton.css';

interface SkeletonProps {
  variant?: 'block' | 'line' | 'circle';
  className?: string;
}

export function Skeleton({ variant = 'block', className = '' }: SkeletonProps) {
  return <span aria-hidden="true" className={`skeleton skeleton_${variant} ${className}`} />;
}
